<template>
    <div class="home_detail">
        <div class="banner"></div>
        <!-- 平台介绍 -->
        <div class="introduce fc" id="introduce">
            <div class="title_name">平台介绍</div>
            <div class="pro_con">
                <div class="info">
                    <img src="@/assets/introduce/introduce_dot.png" alt="">
                    <div class="box">
                        <h3>钢结构行业工业互联网平台</h3>
                        <p>郑州宝冶由原来的面向装配式建筑智能制造行业纵向深入细化为全生命周期绿色钢结构系统集成服务商，装配式钢结构工业互联网平台面向装配式建筑行业，以改革创新为动力，以“创新型制造+全生命周期服务”为发展战略，打造立足河南、面向全国的装配式建筑智能制造行业性工业互联网平台。通过智能化生产线的积累和沉淀积攒了丰富的实践经验，为工业互联网平台提供了整体的可借鉴和参考的经验。
                        </p>
                        <p>平台解决面向目前行业发展的问题和迫切需求，通过互联网、物联网、大数据、智能机器人等技术，全面实现装配式建筑行业领域的技术融合、业务融合和数据融合，并通过探索符合行业特色的机理模型，实现产业链上下游的互利共赢融合发展。
                        </p>
                    </div>
                </div>
                <img src="@/assets/introduce/introduce_platform.png" alt="">
            </div>
        </div>
        <!-- 平台架构 -->
        <div class="framework" id="framework">
            <div class="fc">
                <div class="title_name">平台架构</div>
                <img src="@/assets/introduce/introduce_framework.png" alt="">
            </div>
        </div>
        <!-- 平台用户 -->
        <div class="user fc" id="user">
            <div class="title_name">平台用户</div>
            <div class="containt">
                <img class="user_img" src="@/assets/introduce/introduce_user.png" alt="">
                <div class="text">
                    <img src="@/assets/introduce/introduce_user02.png" alt="">
                    <h4>平台服务用户包括钢结构行业内的生产企业、供应商企业、项目客户、数字化服务企业及个人技术开发者等。</h4>
                    <h4>在平台内，用户类型主要分为：</h4>
                    <p>· 钢结构行业个人用户</p>
                    <p>· 钢结构企业用户</p>
                    <p>· 服务商用户</p>
                </div>
            </div>
        </div>
        <!-- 平台应用 -->
        <div class="application" id="application">
            <div class="fc">
                <div class="title_name">平台应用</div>
                <div class="containt">
                    <div class="text">
                        <img src="@/assets/introduce/introduce_apply02.png" alt="">
                        <h4>多种技术及数据的融合应用是解决实际工业场景问题的关键。</h4>
                        <h4>平台为钢结构企业提供各类数字化应用，助力企业</h4>
                        <p>· 提升产品质量</p>
                        <p>· 降低生产过程损耗</p>
                        <p>· 提高管理能效</p>
                        <p>· 实现智能制造</p>
                    </div>
                    <img src="@/assets/introduce/introduce_apply.png" alt="">
                </div>
            </div>
        </div>
        <!-- 平台数据 -->
        <div class="data fc" id="data">
            <div class="title_name">平台数据</div>
            <div class="containt">
                <img class="data_img" src="@/assets/introduce/introduce_data.png" alt="">
                <div class="text">
                    <img src="@/assets/introduce/introduce_data02.png" alt="">
                    <h4>数据贯穿工业互联网的各个环节，钢结构企业相关工业数据的获取与应用是钢结构行业工业互联网落地的基础。</h4>
                    <h4>平台可以帮助企业：</h4>
                    <p>· 解决钢结构企业终端数据采集的问题</p>
                    <p>· 解决数据与数据间交互、分析的问题</p>
                    <p>· 为钢结构企业转型成功提供基础支撑</p>
                    <p>· 助力钢结构企业决策分析</p>
                </div>
            </div>
        </div>
        <!-- 平台服务 -->
        <div class="service" id="service">
            <div class="fc">
                <div class="title_name">平台服务</div>
                <div class="containt">
                    <div class="text">
                        <img src="@/assets/introduce/introduce_serve02.png" alt="">
                        <h4>平台是工业全要素、全产业链、全价值链连接的枢纽，是实现钢结构行业数字化、网络化、智能化过程中工业资源配置的核心，是信息化和工业化深度融合背景下的新型产业生态体系，支撑着工业资源的泛在连接、弹性供给和高效配置。
                        </h4>
                        <h4>平台提供服务包括：</h4>
                        <p>· 存储与计算服务</p>
                        <p>· 应用开发服务</p>
                        <p>· 平台间调用服务</p>
                    </div>
                    <img class="service_img" src="@/assets/introduce/introduce_serve.png" alt="">
                </div>
            </div>
        </div>
        <!-- 平台价值 -->
        <div class="value" id="value">
            <div class="fc">
                <div class="title_name">平台价值</div>
                <p>平台致力于解决钢结构传统生产到智能建造应用全过程的智能化、设备接入问题及行业经验不足的问题，本平台通过和行业内优秀的厂商合作，以智能建造应用服务为目标，构建钢结构行业工业互联网平台，形成统一的，标准的接口，
                </p>
                <p>平台、厂商、平台用户三方构成了一个互惠互利的良好合作生态。</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "",
    components: {},
    data() {
        return {
            // selectorId:this.$route.query.id
        };
    },
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            this.skipTo(this.$route.query.id)
        })
    },
    methods: {
        /**
       *设置点击导航跳转到指定选择器对应的锚点元素
       * @param {*} selector
       **/
        skipTo(selector) {
            // scrollIntoView() js原生方法，实现锚点滚动过渡
            const target = document.querySelector(selector)
            target.scrollIntoView({ behavior: 'instant' })
            let scrollHeight = target.offsetTop - 64
            window.scrollTo(0, scrollHeight)
        },
    },
};
</script>

<style lang="less" scoped>
.banner {
    height: 400px;
    background: url(../../assets/introduce/introduce_banner.png) center center;
    background-size: 100% 100%;
    // padding-top: 210px;
}

.title_name {
    font-size: 36px;
    line-height: 34px;
    color: #333333;
    text-align: center;
}

.containt {
    display: flex;

    .text {
        img {
            width: 60px;
            height: 49px;
            margin-bottom: 8px;
        }

        h4 {
            // height: 225px;
            font-size: 18px;
            line-height: 40px;
            color: #222222;
            font-weight: normal;
        }

        p {
            font-size: 16px;
            color: #555555;
            line-height: 40px;
        }
    }
}

.introduce {
    height: 812px;

    .title_name {
        height: 148px;
        padding-top: 64px;
        padding-bottom: 47px;
    }

    .pro_con {
        display: flex;
        position: relative;
        height: 600px;

        img {
            width: 640px;
            height: 600px;
            position: absolute;
            right: 0;
        }

        .info {
            img {
                width: 578px;
                height: 38px;
                position: absolute;
                top: 0;
                left: 0;
            }

            .box {
                width: 640px;
                height: 500px;
                box-shadow: 0px 0px 32px 0px rgba(24, 24, 24, 0.06);
                padding: 53px 59px 83px;
                background: url(../../assets/introduce/introduce_writer_bg.png) 95% center no-repeat;
                background-color: #ffffff;
                position: absolute;
                top: 49px;
                z-index: 2;

                h3 {
                    line-height: 23px;
                    font-size: 24px;
                    color: #222222;
                    margin-bottom: 27px;
                }

                p {
                    width: 522px;
                    font-size: 16px;
                    line-height: 32px;
                    color: #555555;
                }
            }
        }
    }
}

.framework {
    height: 889px;
    background-color: #fafbfc;

    .fc {
        .title_name {
            height: 155px;
            padding-top: 63px;
            padding-bottom: 58px;
        }
    }
}

.user {
    height: 575px;

    .title_name {
        height: 172px;
        padding-top: 63px;
        padding-bottom: 75px;
    }

    .containt {
        .text {
            padding-top: 21px;
            width: 580px;
        }

        .user_img {
            margin-left: 46px;
            margin-right: 166px;
            width: 428px;
            height: 338px;
        }
    }
}

.application {
    height: 590px;
    background-color: #fafbfc;

    .title_name {
        height: 147px;
        padding-top: 63px;
        padding-bottom: 50px;
    }

    .containt {
        .text {
            padding-top: 34px;
            width: 476px;
            margin-right: 55px;
        }
    }
}

.data {
    height: 571px;

    .title_name {
        height: 150px;
        padding-top: 66px;
        padding-bottom: 50px;
    }

    .containt {
        .data_img {
            width: 520px;
            height: 360px;
            margin-right: 120px;
        }

        .text {
            padding-top: 10px;
            width: 579px;
        }
    }
}

.service {
    height: 588px;
    background-color: #fafbfc;

    .title_name {
        height: 147px;
        padding-top: 64px;
        padding-bottom: 49px;
    }

    .containt {
        .text {
            width: 598px;
            margin-right: 103px;
        }

        .service_img {
            width: 520px;
            height: 376px;
        }
    }
}

.value {
    height: 280px;
    // background-color: #0055ff;
    background: url(../../assets/introduce/introduce_value_bg.png);

    .fc {
        text-align: center;
        color: #ffffff;

        .title_name {
            color: #ffffff;
            height: 116px;
            padding-top: 64px;
            padding-bottom: 18px;
        }

        p {
            font-size: 18px;
            line-height: 36px;
        }
    }
}
</style>
